module.exports = __webpack_public_path__ + "img/wc-pissoir.eb852e8.png";